<template>
  <div id="dashboard">
    <!-- page header -->
    <div class="bg-white shade py-2 px-3 mb-4" style="margin-top: 15px">
      <h3 style="font-size: 20px">
        <i class="bi bi-person-gear"></i>
        Admin Dashboard
      </h3>
    </div>
    <!-- dashboard component -->
    <div class="row mb-4">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-2 pr-gap">
            <div class="card card-default bg-success shade m-b-0">
              <div class="card-header separator">
                <div class="card-title">Project Aktif</div>
              </div>
              <div
                class="card-body"
                v-html="
                  project_aktif
                    ? project_aktif
                    : `<h3 class='m-t-1 m-b-0'><b>0</b></h3>`
                "
              ></div>
            </div>
          </div>
          <div class="col-md-2 px-gap">
            <div class="card card-default bg-complete shade m-b-0">
              <div class="card-header separator">
                <div class="card-title">Project Trial</div>
              </div>
              <div
                class="card-body"
                v-html="
                  project_trial
                    ? project_trial
                    : `<h3 class='m-t-1 m-b-0'><b>0</b></h3>`
                "
              ></div>
            </div>
          </div>
          <div class="col-md-2 px-gap">
            <div class="card card-default bg-warning text-white shade m-b-0">
              <div class="card-header separator">
                <div class="card-title">Project Pending</div>
              </div>
              <div
                class="card-body"
                v-html="
                  project_pending
                    ? project_pending
                    : `<h3 class='m-t-1 m-b-0'><b>0</b></h3>`
                "
              ></div>
            </div>
          </div>
          <div class="col-md-2 px-gap">
            <div class="card card-default bg-danger shade m-b-0">
              <div class="card-header separator">
                <div class="card-title">Disk Terpakai</div>
              </div>
              <div
                class="card-body"
                v-html="
                  disk_terpakai
                    ? disk_terpakai
                    : `<h3 class='m-t-1 m-b-0'><b>0</b></h3>`
                "
              ></div>
            </div>
          </div>
          <div class="col-md-2 px-gap">
            <div
              class="card card-default bg-complete-light text-white shade m-b-0"
            >
              <div class="card-header separator">
                <div class="card-title">Data 1 Jam Terakhir</div>
              </div>
              <div
                class="card-body"
                v-html="
                  sejam_terakhir
                    ? sejam_terakhir
                    : `<h3 class='m-t-1 m-b-0'><b>0</b></h3>`
                "
              ></div>
            </div>
          </div>
          <div class="col-md-2 pl-gap">
            <div class="card card-default bg-secondary text-white shade m-b-0">
              <div class="card-header separator">
                <div class="card-title">Est. API Req/Project</div>
              </div>
              <div
                class="card-body"
                v-html="
                  estimasi_req
                    ? estimasi_req
                    : `<h3 class='m-t-1 m-b-0'><b>0</b></h3>`
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="bg-white py-2 px-3 shade mb-4">
          <div class="row">
            <div class="col-md-7">
              <h4 class="m-b-0">Project</h4>
              <p class="hint-text m-b-0">Daftar dan detail Project</p>
            </div>
            <div class="col-md-5">
              <div class="p-t-20 p-r-10">
                <router-link
                  to="/admin/project/step1"
                  class="btn btn-icon-left btn-success pull-right"
                >
                  <i class="bi bi-plus"></i> <span>Tambah Project</span>
                </router-link>
                <div
                  class="form-check switch switch-lg complete pull-right mr-5"
                >
                  <input
                    type="checkbox"
                    id="pagesSwitchExpired"
                    :checked="isShowExpired"
                    @click="showExpired(isShowExpired ? false : true)"
                  />
                  <label for="pagesSwitchExpired" class="full-width"
                    >Hide Expired
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="list-project bg-white shade">
          <div>
            <table class="table table-bordered" id="list-project-table">
              <thead>
                <tr>
                  <th width="5%" class="text-center">No</th>
                  <th>Project</th>
                  <th>Alias</th>
                  <th width="10%" class="text-center">Tanggal Expire</th>
                  <th width="5%" class="text-center">Status</th>
                  <th width="10%" class="text-center">Versi Aplikasi</th>
                  <th width="10%" class="text-center">Last Update</th>
                  <th width="10%" class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="is_loading">
                  <td colspan="8" align="center">Loading...</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal_data"
    />
  </div>
</template>

<script>
import $ from "jquery";
import swal from "sweetalert";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_log from "@/views/components/super-admin/detail-project/modal_log.vue";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;

export default {
  name: "DashboardAdmin",
  title: "Admin Dashboard | Online Media Monitoring",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      project_aktif: null,
      project_trial: null,
      project_pending: null,
      disk_terpakai: null,
      sejam_terakhir: null,
      estimasi_req: null,

      modal_key: 0,
      modal_data: null,
      modal: null,

      table: null,
      projects: null,
      status_project: [],
      is_loading: false,
      isShowExpired: true,
    };
  },
  methods: {
    getProject: function () {
      let activeOnly = this.isShowExpired ? "?activeOnly=true" : "";
      let api = process.env.VUE_APP_API_URL + "projects" + activeOnly;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.setStats(response.data.stats);
            this.projects = response.data.projects;
          } else {
            this.projects = {};
          }
          this.generateTable("#list-project-table", this.projects);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    showExpired: function (status) {
      this.isShowExpired = status;
      this.getProject();
    },
    setStats: function (stats) {
      let total = stats.active + stats.trial + stats.pending;
      let persentase = 0;

      persentase =
        stats.active > 0 ? ((stats.active / total) * 100).toFixed(2) : 0;
      var project_aktif =
        '<h3 class="m-t-1 m-b-0"><b>' +
        stats.active +
        ' <span class="fs-14">(' +
        persentase +
        "%)</span></b></h3>";
      this.project_aktif = project_aktif;

      persentase =
        stats.trial > 0 ? ((stats.trial / total) * 100).toFixed(2) : 0;
      var project_trial =
        '<h3 class="m-t-1 m-b-0"><b>' +
        stats.trial +
        '</b> <span class="fs-14">(' +
        persentase +
        "%)</span></h3>";
      this.project_trial = project_trial;

      persentase =
        stats.pending > 0 ? ((stats.pending / total) * 100).toFixed(2) : 0;
      var project_pending =
        '<h3 class="m-t-1 m-b-0"><b>' +
        stats.pending +
        '</b> <span class="fs-14">(' +
        persentase +
        "%)</span></h3>";
      this.project_pending = project_pending;

      var disk_terpakai =
        '<h3 class="m-t-1 m-b-0"><b>' +
        this.formatBytes(stats.size) +
        "</b></h3>";
      this.disk_terpakai = disk_terpakai;

      var sejam_terakhir =
        '<h3 class="m-t-1 m-b-0"><b>' + stats.last_hour_n + "</b></h3>";
      this.sejam_terakhir = sejam_terakhir;

      persentase = total > 0 ? 450 / (total * 2) : 450;
      var estimasi_req =
        '<h3 class="m-t-1 m-b-0"><b>' + persentase.toFixed(2) + "</b></h3>";
      this.estimasi_req = estimasi_req;
    },
    formatBytes: function (a, b = 2) {
      if (0 === a) return "0 Bytes";
      const c = 0 > b ? 0 : b,
        d = Math.floor(Math.log(a) / Math.log(1024));
      return (
        parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
        " " +
        ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
      );
    },
    stopProject: function (index) {
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghentikan project ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let self = this;
          let api = process.env.VUE_APP_API_URL + "project-update";
          let param = {
            _id: self.projects[index]._id,
            name: self.projects[index].name,
            alias: self.projects[index].alias,
            logo: self.projects[index].logo,
            status: 0,
            periode_from: self.projects[index].periode_from,
            periode_to: self.projects[index].periode_to,
            keyword_limit: self.projects[index].keyword_limit,
          };
          self.$http
            .post(api, param)
            .then((response) => {
              if (response.status == 200) {
                self.getProject();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Project berhasil dihentikan!',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                      response.data,
                    position: "top-right",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch((error) => {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                    error.response.data,
                  position: "top-right",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    deleteProject: function (id) {
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus project ini. Pastikan status project dalam keadan Stop sebelum menghapus project.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yes) => {
        if (yes) {
          let param = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "project-delete";
          this.$http
            .post(api, param)
            .then((response) => {
              if (response.status == 200) {
                this.getProject();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Project berhasil dihapus!',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                      response.data.status,
                    position: "top-right",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch((error) => {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                    error.response.data.status,
                  position: "top-right",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    showLogCrawler: function (id) {
      this.modal_data = new Array();
      this.modal_data.push(this.projects[id]);
      this.modal = {
        title: "Log " + this.projects[id].name,
        subtitle: "",
        component: modal_log,
      };
      this.modal_key++;
    },
    generateTable: function (id, data) {
      let versi_aplikasi = [];
      versi_aplikasi[1] = "KURASI";
      versi_aplikasi[2] = "KABAYAN";
      versi_aplikasi[3] = "DIGIVLA";
      let c = 0;
      let self = this;
      this.table = $(id).DataTable({
        destroy: true,
        data: data,
        language: {
          emptyTable: "Mohon maaf, data tidak tersedia!",
        },
        fnCreatedRow: function (nRow, aData, iDataIndex) {
          $(nRow).attr("id", iDataIndex);
        },
        columns: [
          { data: "no" },
          { data: "name" },
          { data: "alias" },
          { data: "periode_to" },
          { data: "status" },
          { data: "tipe" },
          { data: "crawler" },
          { data: "action" },
        ],
        columnDefs: [
          {
            render: function () {
              c++;
              let btn = `<center>${c}</center>`;
              return btn;
            },
            targets: 0,
          },
          {
            render: function (data, type, row) {
              var ONE_DAY = 1000 * 60 * 60 * 24;
              var tgl_project = new Date(row.periode_to);
              var tgl_now = new Date();
              var difference_ms = tgl_project - tgl_now;
              var res = Math.round(difference_ms / ONE_DAY);
              let tgl = "";
              if (res <= 3) {
                tgl =
                  row.periode_to +
                  "<i class='bi bi-exclamation-triangle text-danger'></i>";
              } else if (res <= 7) {
                tgl =
                  row.periode_to +
                  "<i class='bi bi-exclamation-triangle' style='color:orange;'></i>";
              } else {
                tgl = row.periode_to;
              }
              return `<center>${tgl}</center>`;
            },
            targets: 3,
          },
          {
            render: function (data) {
              let btn = `<center>${self.status_project[data]}</center>`;
              return btn;
            },
            orderable: false,
            targets: 4,
          },
          {
            render: function (data) {
              let btn = `<center>${versi_aplikasi[data]}</center>`;
              return btn;
            },
            orderable: false,
            targets: 5,
          },
          {
            render: function () {
              let btn =
                '<center><button class="btn btn-success btn-sm m-r-5 see-log" ><i class="m-r-5 bi bi-eye"></i> Lihat Log</button></center>';
              return btn;
            },
            orderable: false,
            targets: 6,
          },
          {
            render: function (data, type, row) {
              let btn =
                '<center><button class="btn btn-complete btn-sm m-r-5 see" data-id="' +
                row._id +
                '"><i class="bi bi-pencil-square"></i></button>';
              btn +=
                '<button class="btn btn-danger btn-sm del" data-id="' +
                row._id +
                '"><i class="bi bi-trash"></i></button></center>';
              return btn;
            },
            orderable: false,
            targets: 7,
          },
        ],
      });
    },
  },
  created: function () {
    this.status_project[0] =
      '<span class="label label-important">Stopped</span>';
    this.status_project[1] = '<span class="label label-success">Running</span>';
    this.status_project[2] = '<span class="label label-info">Trial</span>';
    this.status_project[3] = '<span class="label label-warning">Pending</span>';
    this.status_project[4] = '<span class="label">Development</span>';
  },
  mounted: function () {
    let self = this;
    this.getProject();
    $("#list-project-table tbody").on("click", ".see", function () {
      var tr = $(this).closest("tr");
      let index = $(tr).attr("id");
      let id = self.projects[index]._id;
      self.$router.push({
        path: "/admin/project/detail",
        query: { ref: btoa(id) },
      });
    });
    $("#list-project-table tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let index = $(tr).attr("id");
      let id = self.projects[index]._id;
      self.deleteProject(id);
    });
    $("#list-project-table tbody").on("click", ".see-log", function () {
      var tr = $(this).closest("tr");
      let index = $(tr).attr("id");
      self.showLogCrawler(index);
    });
  },
};
</script>

<style scoped>
.list-project {
  padding: 20px 15px;
}
.detail-project {
  padding: 20px 15px;
}
.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
.table tbody tr td {
  padding: 8px 10px;
}
</style>